<template lang="html">
  <div class="mb4 pv3 ph4 pl-box-shadow">
    <div class="row col-xs center-xs middle-xs title">
      <span>Verbal RoundTable Engagement</span>
      <i
        v-my-tooltip="liveRoundtableEngagementTooltip"
        class="fa fa-info-circle"
        style="color: #848484"
        aria-hidden="true"
      />
    </div>
    <canvas id="live-roundtable-engagement-data"></canvas>
  </div>
</template>
<script>
  import Chart from 'chart.js';
  export default {
    data() {
      return {
        liveRoundtableEngagementTooltip:
          'This chart shows the cumulative number of tap ins (new ideas, build ons, challenges, questions), “votes” to encourage others to participate, and applause given by students to their peers across all Verbal RoundTables in each of the months between the selected dates.',
        myLineChart: [],
      };
    },
    watch: {
      liveRTEngagement() {
        this.myLineChart.destroy();
        this.createEngagementGraph();
      },
    },
    props: {
      liveRTEngagement: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    methods: {
      createEngagementGraph() {
        const payload = {
          type: 'bar',
          data: [],
        };
        const array = [];
        if (this.liveRTEngagement && this.liveRTEngagement.length) {
          const month = this.liveRTEngagement.map((label) => {
            const [year, month] = label.month.split('T')[0].split('-');

            return `${month}/${year}`;
          });
          payload.data.labels = month;
          const applauses_count = this.liveRTEngagement.map(
            (data) => data.live_roundtables_engagement.applauses_count
          );
          const build_ons_count = this.liveRTEngagement.map(
            (data) => data.live_roundtables_engagement.build_ons_count
          );
          const challenges_count = this.liveRTEngagement.map(
            (data) => data.live_roundtables_engagement.challenges_count
          );
          const encouragements_count = this.liveRTEngagement.map(
            (data) => data.live_roundtables_engagement.encouragements_count
          );
          const new_ideas_count = this.liveRTEngagement.map(
            (data) => data.live_roundtables_engagement.new_ideas_count
          );
          const questions_count = this.liveRTEngagement.map(
            (data) => data.live_roundtables_engagement.questions_count
          );
          const by_teacher_count = this.liveRTEngagement.map(
            (data) => data.live_roundtables_engagement.by_teacher_count
          );
          array.push(
            {
              type: 'line',
              label: 'Encourage Others',
              fill: false,
              borderColor: '#F86900',
              backgroundColor: '#F86900',
              tension: 0,
              data: encouragements_count,
            },
            {
              type: 'line',
              label: 'Applause',
              fill: false,
              borderColor: '#FFCC33',
              backgroundColor: '#FFCC33',
              tension: 0,
              data: applauses_count,
            },
            {
              label: 'New Ideas',
              stack: 'bar-stacked',
              borderColor: '#85D7E2',
              backgroundColor: '#85D7E2',
              data: new_ideas_count,
            },
            {
              label: 'Challenges',
              stack: 'bar-stacked',
              borderColor: '#F33795',
              backgroundColor: '#F33795',
              data: challenges_count,
            },
            {
              label: 'Build Ons',
              stack: 'bar-stacked',
              borderColor: '#70BD66',
              backgroundColor: '#70BD66',
              data: build_ons_count,
            },
            {
              label: 'Questions',
              stack: 'bar-stacked',
              borderColor: '#00008B',
              backgroundColor: '#00008B',
              data: questions_count,
            },
            {
              label: 'Added by Teacher',
              stack: 'bar-stacked',
              borderColor: '#FFA500',
              backgroundColor: '#FFA500',
              data: by_teacher_count,
            }
          );
          (payload.data.datasets = array),
            (payload.options = {
              responsive: true,
              legend: {
                onHover: function (e) {
                  e.target.style.cursor = 'pointer';
                },
                labels: {
                  usePointStyle: true,
                  boxWidth: 7,
                },
              },

              scales: {
                xAxes: [
                  {
                    display: true,
                  },
                ],
                yAxes: [
                  {
                    display: true,
                    beginAtZero: true,
                  },
                ],
              },
              tooltips: {
                xPadding: 25,
                yPadding: 15,
                titleAlign: 'center',
                footerAlign: 'center',
                bodyAlign: 'left',
                backgroundColor: '#fff',
                titleFontColor: '#595959',
                bodyFontColor: '#595959',
                footerFontColor: '#595959',
                borderWidth: 0.2,
                borderColor: '#595959',
                callbacks: {
                  label: function (tooltipItem, data) {
                    return (
                      data.datasets[tooltipItem.datasetIndex].label +
                      ': ' +
                      data.datasets[tooltipItem.datasetIndex].data[
                        tooltipItem.index
                      ]
                    );
                  },
                },
                bodyFontSize: 20,
                displayColors: false,
              },
              hover: {
                onHover: function (e) {
                  var point = this.getElementAtEvent(e);
                  if (point.length) e.target.style.cursor = 'pointer';
                  else e.target.style.cursor = 'default';
                },
              },
            });
        }

        const ctx = document.getElementById('live-roundtable-engagement-data');
        this.myLineChart = new Chart(ctx, payload);
      },
    },
    mounted() {
      this.createEngagementGraph();
    },
  };
</script>
<style scoped lang="stylus">
  .title
    margin: 0 0 20px 0
    span
      margin-right: 10px
      font-size: 20px
      font-weight: 600
</style>



// WEBPACK FOOTER //
// liveRoundtableEngagement.vue?716fe614